import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Star, Clock, MapPin } from 'lucide-react';
import { Button } from './ui/button';

export const CruiseCard = ({ cruise }) => (
  <div className="group relative bg-white rounded-2xl overflow-hidden shadow-sm hover:shadow-2xl transition-all duration-500 border border-slate-100 flex flex-col">
    <Link to={`/cruises/${cruise.slug}`} className="relative overflow-hidden aspect-[4/3] block">
      <img src={cruise.image} alt={cruise.name} className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700" />
      <div className="absolute top-4 left-4 bg-white/95 backdrop-blur px-3 py-1 rounded-full text-xs font-semibold text-[#304b71]">{cruise.category}</div>
      <div className="absolute top-4 right-4 bg-[#304b71] text-white px-3 py-1 rounded-full text-xs flex items-center gap-1">
        <Star size={12} fill="currentColor" /> {cruise.rating?.toFixed(1) || '4.9'}
      </div>
      <div className="absolute inset-x-0 bottom-0 h-24 bg-gradient-to-t from-black/60 to-transparent" />
    </Link>
    <div className="p-6 flex-1 flex flex-col">
      <div className="text-xs uppercase tracking-widest text-[#6a8aa4] mb-2">{cruise.tag}</div>
      <Link to={`/cruises/${cruise.slug}`}>
        <h3 className="font-serif text-xl text-[#304b71] leading-snug group-hover:text-[#6a8aa4] transition-colors">{cruise.name}</h3>
      </Link>
      <div className="flex flex-wrap gap-x-4 gap-y-1 mt-3 text-xs text-slate-500">
        <span className="inline-flex items-center gap-1"><Clock size={12} /> {cruise.duration}</span>
        <span className="inline-flex items-center gap-1"><MapPin size={12} /> {cruise.route}</span>
      </div>
      <div className="mt-5 flex items-end justify-between pt-4 border-t border-slate-100">
        <div>
          <div className="text-[11px] uppercase tracking-widest text-slate-500">{cruise.price_label || 'Start from'}</div>
          <div className="font-serif text-2xl text-[#304b71] flex items-baseline gap-2">
            ${cruise.price?.toLocaleString()}
            {cruise.old_price && <span className="text-xs text-slate-400 line-through font-sans">${cruise.old_price?.toLocaleString()}</span>}
            <span className="text-xs text-slate-500 font-sans">/ USD</span>
          </div>
        </div>
        <Button asChild size="sm" className="bg-[#304b71] hover:bg-[#6a8aa4] text-white rounded-full">
          <Link to={`/cruises/${cruise.slug}`}>View <ArrowRight size={14} className="ml-1" /></Link>
        </Button>
      </div>
    </div>
  </div>
);

export const PackageCard = ({ pkg }) => (
  <div className="group bg-white rounded-2xl overflow-hidden border border-slate-100 hover:border-[#6a8aa4] hover:shadow-xl transition-all duration-500 flex flex-col">
    <Link to={`/packages/${pkg.slug}`} className="relative aspect-[4/3] overflow-hidden block">
      <img src={pkg.image} alt={pkg.name} className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700" />
      <div className="absolute top-4 left-4 bg-[#304b71] text-white px-3 py-1 rounded-full text-xs font-semibold flex items-center gap-1">
        <Clock size={11} /> {pkg.days}
      </div>
    </Link>
    <div className="p-5 flex-1 flex flex-col">
      <div className="text-[10px] uppercase tracking-widest text-[#6a8aa4] mb-2">{pkg.tag}</div>
      <Link to={`/packages/${pkg.slug}`}>
        <h3 className="font-serif text-lg text-[#304b71] leading-snug group-hover:text-[#6a8aa4] transition-colors flex-1">{pkg.name}</h3>
      </Link>
      <div className="mt-5 flex items-end justify-between pt-4 border-t border-slate-100">
        <div>
          <div className="text-[10px] uppercase tracking-widest text-slate-500">{pkg.price_label || 'Start from'}</div>
          <div className="font-serif text-xl text-[#304b71]">${pkg.price?.toLocaleString()} <span className="text-[10px] text-slate-500 font-sans">/ USD</span></div>
        </div>
        <Button asChild size="sm" className="bg-transparent hover:bg-[#304b71] text-[#304b71] hover:text-white border border-[#304b71] rounded-full text-xs h-8">
          <Link to={`/packages/${pkg.slug}`}>View</Link>
        </Button>
      </div>
    </div>
  </div>
);
